'use client';
import React, { useMemo, useState } from 'react';

import CarouselContainer from '@/components/ui/CarouselContainer/CarouselContainer';
const CardCarousel = CarouselContainer; // ponytail: preserve original name from molecules barrel
import { COMPONENT_STYLES } from '@/constants/styles';
import { CoverflowCarouselSection } from '@/types/coverflowCarousel';

import { transformCarouselData } from './helpers';

export interface ContentCarouselProps {
  data: CoverflowCarouselSection;
  /** Optional data transformation function for dependency isolation and testing */
  transformData?: typeof transformCarouselData;
}

const ContentCarousel: React.FC<ContentCarouselProps> = ({
  data,
  transformData = transformCarouselData,
}) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const { carouselData, carouselItems } = useMemo(() => {
    if (!data)
      return {
        carouselData: { heading: '', description: '' },
        carouselItems: [],
      };
    return transformData(data);
  }, [data, transformData]);

  if (!data) return null;

  if (!carouselItems.length) return null;

  const handleNext = () => {
    setActiveIndex((prev) => (prev + 1) % carouselItems.length);
  };

  const handlePrev = () => {
    setActiveIndex(
      (prev) => (prev - 1 + carouselItems.length) % carouselItems.length,
    );
  };

  return (
    <div
      className={`py-8 md:py-10 ${COMPONENT_STYLES.LAYOUT.CONTENT_WRAPPER}`}
      data-testid="content-carousel"
    >
      <CardCarousel
        data={carouselData}
        items={carouselItems}
        activeIndex={activeIndex}
        setActiveIndex={setActiveIndex}
        onNext={handleNext}
        onPrev={handlePrev}
      />
    </div>
  );
};

export default ContentCarousel;
